import { ProgressSpinner } from 'primereact/progressspinner';

interface LoadingSpinnerProps {
  className?: string;
  /** Diameter of the spinner, e.g. "50px". */
  size?: string;
}

export const LoadingSpinner = ({ className, size = '50px' }: LoadingSpinnerProps) => (
  <div className={`flex justify-center items-center p-8 ${className || ''}`}>
    <ProgressSpinner style={{ width: size, height: size }} />
  </div>
);

export default LoadingSpinner;
